<!-- 数据中心 — 我的数据集 -->
<template>
  <div class="dataset-list">
    <div class="pretrain-header header">
      <h3 class="title">
        <span
          :class="[display === 'versionList' ? 'go-model' : '']"
          :title="display === 'versionList' ? '返回我的模型列表' : ''"
          @click="showDatasetList"
          >我的数据集</span
        >
        <span
          class="modelName-span"
          :title="datasetName"
          v-if="display === 'versionList'"
        >
          <i class="el-icon-arrow-right"></i>
          {{ display === 'versionList' ? datasetName : '' }}
        </span>
      </h3>
      <div class="tools" v-if="display === 'datasetList'">
        <el-input
          placeholder="请输入数据集名称"
          v-model.trim="key"
          @keyup.enter.native="searchDatasetByName"
        >
          <i slot="suffix" class="icon-search-box" @click="searchDatasetByName">
            <icon-base class="icon-search" v-bind="Icons.search">
              <icon-search class="clr_b4bbcb" />
            </icon-base>
          </i>
        </el-input>
        <!-- <button class="btn-create" @click="createDataset"></button> -->
        <span class="btn-create" @click="createDataset"><i class="el-icon-circle-plus-outline"></i>创建数据集</span>
      </div>
    </div>
    <div class="main">
      <table class="tb-data" v-if="display === 'datasetList'">
        <thead class="tb-head">
          <tr class="tb-head-r">
            <th class="tb-name">数据集名称</th>
            <th class="tb-tags">版本数</th>
            <!-- <th class="tb-picture">{{tbPictureFilter(modelType)}}</th>
            <th class="status">状态</th> -->
            <th class="tb-action">操作</th>
          </tr>
        </thead>
        <tbody class="tb-body">
          <tr
            class="tb-body-r"
            v-for="(item, idx) in Dataset.records"
            :key="idx"
          >
            <td class="tb-name" :title="item.datasetName">
              {{ item.datasetName }}
            </td>
            <td class="tb-tags">
              <span class="edition" @click="versionVisible(item, idx)">{{
                item.versionNum | striping
              }}</span>
            </td>
            <td class="tb-action">
              <button
                class="btn-opt btn-edite"
                @click="activeUpdatePopup(item.datasetName, idx)"
              >
                <i class="icon_box icon-edi"></i>
              </button>
              <!-- <span class="sep"></span> -->
              <!-- <button
                class="btn-opt btn-del"
                @click="activeDeletePopup(item.datasetId, idx)"
              >
                <i class="icon_box icon-del"></i>
              </button> -->
            </td>
          </tr>
        </tbody>
      </table>
      <table class="tb-data" v-if="display === 'versionList'">
        <thead class="tb-head">
          <tr class="tb-head-r">
            <!-- <th class="tb-name">数据集名称</th> -->
            <th class="tb-tags">版本号</th>
            <th class="tb-tags">标签数</th>
            <th class="tb-picture">{{ tbPictureFilter(modelType) }}</th>
            <th class="status">状态</th>
            <th class="tb-action">操作</th>
          </tr>
        </thead>
        <tbody class="tb-body">
          <tr
            class="tb-body-r"
            v-for="(item, idx) in versionSet.records"
            :key="idx"
          >
            <!-- <td class="tb-name" :title="item.datasetName">
              {{ item.datasetName }}
            </td> -->
            <td class="tb-tags">
              {{ item.version }}
            </td>
            <td class="tb-tags">
              {{ item.labelNum | striping }}
            </td>
            <td class="tb-picture">
              {{ item | stripingNum }}
            </td>
            <td class="status">
              {{ item.status }}
            </td>
            <!-- <td class="status">图片不足</td> -->
            <td class="tb-action tb-action-version">
              <button
                class="btn-opt btn-del btn-color"
                @click="operateRedirect(item, idx)"
              >
                {{
                  modelType == 1 || modelType == 3 || modelType == 5
                    ? '分类'
                    : '标注'
                }}
              </button>
              <span class="sep"></span>
              <button
                class="btn-opt btn-del btn-color"
                @click="copyDataset(item, idx)"
              >
                复制
              </button>
              <span class="sep"></span>
              <button
                :class="[
                  'btn-opt',
                  'btn-del',
                  reg_status.test(item.status) ? 'btn-color' : 'btn-forbid',
                ]"
                @click="releaseDataset(item)"
              >
                发布
              </button>
              <!-- <button
                class="btn-opt btn-edite"
                @click="activeUpdatePopup(item.datasetId, idx)"
              >
                <i class="icon_box icon-edi"></i>
              </button> -->
              <span class="sep"></span>
              <button
                class="btn-opt btn-del"
                @click="activeDeletePopup(item.datasetId, idx)"
              >
                <i class="icon_box icon-del"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="totalCount"
          v-if="totalCount && totalCount >= 10"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 创建/修改数据集 -->
      <gat-popup
        :class="['popup-update', popupActive === 'create' || popupActive === 'update' ? 'on' : 'off']"
        :title="popupActive === 'create' ? '创建数据集' : '数据集修改'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="updateDataset"
      >
        <template v-slot:content>
          <div class="intxt">
            <span class="label"><i class="required">*</i>数据集名称：</span>
            <el-input
              placeholder="请输入数据集名称"
              v-model.trim="popupData.update.datasetName"
              maxlength="20"
              show-word-limit
            />
          </div>
          <div class="intxt">
            <span class="label"><i class="required">*</i>数据集描述：</span>
            <el-input
              v-model.trim="popupData.update.datasetContent"
              type="textarea"
              :rows="6"
              maxlength="200"
              show-word-limit
              placeholder="请输入数据集描述"
            />
          </div>
        </template>
      </gat-popup>

      <!-- 删除 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteDataset"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">确定删除此数据集吗？</span>
            </div>
            <div class="content">删除后可在 “回收站” 恢复哦</div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'
import IconSearch from '@/components/icons/typography/Search'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import PRETRAIN from '@/axios/pretrain/pretrain.js'

export default {
  name: 'dataset-list',
  components: { GatPopup, IconSearch, IconInfoHelp },
  filters: {
    striping(value) {
      var result = value
      if (value < 0) {
        result = '--'
      } else if (isNaN(value)) {
        result = 'NaN'
      }
      return result
    },
    // 根据图片/文本/音频 返回对应的统计数量字段
    stripingNum(obj) {
      let result = '--',
        modelType = obj.type
      // modelType = this.modelType
      if (modelType == 1 || modelType == 2) {
        result = obj.imgNum == 0 ? '--' : obj.imgNum
      } else if (modelType == 3 || modelType == 4) {
        result = obj.allTextNum == 0 ? '--' : obj.allTextNum
      } else if (modelType == 5 || modelType == 6) {
        result = obj.allAudioNum == 0 ? '--' : obj.allAudioNum
      }
      return result
    },
    // filterStatus(dataset) {
    //   let status = dataset.status,
    //     bool
    //   if (/准备就绪/.test(status)) {
    //     bool = true
    //   } else if (/新建|标签|图片数不足/.test(status)) {
    //     bool = false
    //   }
    //   return bool
    // },
  },
  data() {
    return {
      display: 'datasetList',
      Dataset: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
      },
      datasetName: '',
      //版本数
      //版本数
      versionSet: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
      },
      datasetTemp: {},
      pageIndex: 1,
      currentPage: 1,
      popupActive: '',
      popupData: {
        update: {
          datasetId: '',
          index: -1,
          datasetContent: '',
          datasetName: '',
        },
      },
      modelType: 1,
      key: '', // 搜索关键字
      Icons: {
        search: {
          iconName: '搜索',
          viewBox: '0 0 20 20',
          width: '20',
          height: '20',
        },
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      reg_status: /准备就绪/,
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
    totalCount() {
      return this.display === 'datasetList'
        ? this.Dataset.total
        : this.versionSet.total
    },
  },
  watch: {
    // eslint-disable-next-line
    $route(to, from) {
      this.modelType = this.$route.params.modeltype // 1/3/5分类、2/4/6标注
    },
    token() {
      this.getDatasetPageList()
    },
  },
  mounted() {
    this.modelType = this.$route.params.modeltype // 1/3/5分类、2/4/6标注
    this.popupActive = this.$route.params.create || '' // 训练模型过来弹出创建窗口
    if (this.token) {
      this.getDatasetPageList()
    }
  },
  methods: {
    showDatasetList() {
      this.display = 'datasetList'
      this.currentPage = this.Dataset.current
      this.Dataset.records =[]
      this.getDatasetPageList(this.currentPage)
    },
    tbPictureFilter(type) {
      if (type == 1) {
        return '图片数'
      } else if (type == 2) {
        // return '图片标注数'
        return '已标注图片数'
      } else if (type == 3) {
        return '文本数'
      } else if (type == 4) {
        return '文本标注数'
      } else if (type == 5) {
        return '音频数'
      } else if (type == 6) {
        return '音频片段数'
      }
    },

    versionVisible(dataset, index) {
      this.display = 'versionList'
      this.activeModel = index
      this.datasetName = dataset.datasetName
      this.versionSet.current = 1
      this.currentPage = this.versionSet.current
      this.versionSet.records = []
      this.getMyDatasetVersionList(this.currentPage)
    },
    /**
     * 查询当前账号下我的数据集列表  @data  "datasetName"数据集名称；"type"类型； pageNum当前页数  pageSize每页条数
     */
    getDatasetPageList(pageIndex) {
      var pageNum = pageIndex ? pageIndex : this.Dataset.current,
        pageSize = this.Dataset.size,
        key = this.key,
        datasetName = '',
        data = {
          type: this.modelType,
          pageNum: pageNum,
          pageSize: pageSize,
          datasetName,
        }

      if (key) {
        data.datasetName = key
      }

      PRETRAIN.getMyDatasetList(data).then((result) => {
        if (result.isSuccess) {
          this.Dataset = result.data
        }
      })
    },
    /**
     * 查询数据集版本列表  @data  "datasetName"数据集名称；"type"类型； pageNum当前页数  pageSize每页条数
     */
    getMyDatasetVersionList(pageIndex) {
      var pageNum = pageIndex ? pageIndex : this.versionSet.current,
        pageSize = this.Dataset.size,
        datasetName = this.datasetName,
        // key = this.key,
        data = {
          type: this.modelType,
          pageNum: pageNum,
          pageSize: pageSize,
          datasetName,
        }

      // if (key) {
      //   data.datasetName = key
      // }
      PRETRAIN.getMyDatasetVersionList(data).then((result) => {
        if (result.isSuccess) {
          this.versionSet = result.data
        }
      })
    },
    //复制数据集
    copyDataset(dataset) {
      let { datasetId, datasetName, type } = dataset,
        data = {
          datasetId,
          type,
          // datasetName,
        }
      console.log('copy---')
      // if (!this.reg_status.test(dataset.status)) return

      PRETRAIN.copyDataset(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          this.getMyDatasetVersionList(this.pageIndex)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    //发布数据集
    releaseDataset(dataset) {
      let { datasetId, datasetName } = dataset,
        data = {
          datasetId,
          datasetName,
        }
      if (!this.reg_status.test(dataset.status)) return

      PRETRAIN.releaseDataset(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          this.getMyDatasetVersionList(this.pageIndex)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 分类、标注跳转
    operateRedirect(dataset /*, idx*/) {
      //
      var route = {},
        modelType = this.modelType,
        { datasetId, datasetName } = dataset

      if (modelType == 1) {
        // 图片分类
        route.name = 'dataset-classify'
      } else if (modelType == 2) {
        // 物体检测
        route.name = 'dataset-label'
      } else if (modelType == 3) {
        // 文本分类
        route.name = 'dataset-categorization'
      } else if (modelType == 4) {
        // 文本标注
        route.name = 'dataset-annotation'
      } else if (modelType == 5) {
        // 音频分类
        route.name = 'dataset-audioCategorization'
      } else if (modelType == 6) {
        // 音频标注
        route.name = 'dataset-audioAnnotation'
      }
      route.params = {}
      route.params.modeltype = modelType
      route.params.datasetId = datasetId
      route.params.datasetName = datasetName
      route.params.origin = 'dataList'
      console.log('route', route)
      this.$router.push(route)
    },
    // 新建数据集跳转
    createDataset() {
      this.popupData = {
        update: {
          datasetId: '',
          index: -1,
          datasetContent: '',
          datasetName: '',
        },
      };
      this.popupActive = 'create';
      // var params = this.$route.params,
      //   params_ = Object.assign({}, params)

      // this.$router.push({
      //   name: 'dataset-create',
      //   params: params_,
      // })
    },
    // 数据集删除激活
    activeDeletePopup(datasetId, index) {
      var dataset = this.versionSet.records[index]

      this.popupData.update.datasetId = datasetId
      this.popupData.update.index = index
      this.popupData.update.datasetName = dataset.datasetName
      this.popupData.update.datasetContent = dataset.datasetContent
      this.popupActive = 'delete'
    },
    // 删除数据集
    deleteDataset() {
      var datasetId = this.popupData.update.datasetId,
        datasetName = this.popupData.update.datasetName,
        modelType = this.modelType,
        data = {
          datasetId: datasetId,
          datasetName: datasetName,
          type: modelType,
        }

      // 关闭弹窗
      this.cancelPopup()

      PRETRAIN.deleteDataset(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          console.log('currentPage', this.currentPage)
          if (this.currentPage > 1) {
            if (this.versionSet.records.length === 1) {
              this.currentPage = this.currentPage - 1
            }
            this.getMyDatasetVersionList(this.currentPage)
          } else if (this.currentPage == 1) {
            if (this.versionSet.records.length > 1) {
              this.getMyDatasetVersionList(this.currentPage)
            } else {
              //切换为获取数据集
              this.showDatasetList()
            }
          }
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 数据集修改激活
    activeUpdatePopup(datasetName, index) {
      var dataset = this.Dataset.records[index]
      this.popupData.update.datasetName = datasetName
      this.popupData.update.index = index
      // this.popupData.update.datasetName = dataset.datasetName
      this.popupData.update.datasetContent = dataset.datasetContent
      this.datasetTemp = dataset
      this.popupActive = 'update'
      // TODO:弹窗数据传递
      // this.popupData = this.Dataset.records[idx];
    },
    /**
     * 创建/修改数据集  @data  "datasetId"数据集id datasetContent数据集简介  datasetName数据集名称
     */
    updateDataset() {
      // TODO:弹窗数据传递
      var index = this.popupData.update.index,
        // datasetId = this.popupData.update.datasetId,
        newDatasetName = this.popupData.update.datasetName,
        datasetContent = this.popupData.update.datasetContent,
        modelType = this.modelType,
        oldDatasetName = this.datasetTemp.datasetName,
        oldDatasetContent = this.datasetTemp.datasetContent,
        data = {},
        items = [];

      if (!newDatasetName || !datasetContent) {
        return this.$message.error('请将数据相关信息填写完整')
      }
        
      if (this.popupActive === 'create') {
        // TODO:数据集描述还需要处理
        data = Object.assign(data, {
          datasetName: newDatasetName,
          datasetContent: datasetContent,
          type: modelType,
        });
  
        PRETRAIN.addDataset(data).then(result => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg);
            this.getDatasetPageList(1)
            this.cancelPopup()
          } else {
            this.$message.error(result.returnMsg);
          }
        });
      } else {
        data = {
          // datasetId: datasetId,
          newDatasetName: newDatasetName,
          oldDatasetName,
          datasetContent: datasetContent,
          type: modelType,
        };
  
        if (
          newDatasetName == oldDatasetName &&
          datasetContent == oldDatasetContent
        ) {
          return this.$message.warning('没有修改的内容')
        }
  
        PRETRAIN.updateDataset(data).then((result) => {
          if (result.isSuccess) {
            this.$message.success(result.returnMsg)
            items = JSON.parse(JSON.stringify(this.Dataset.records))
            items[index].datasetName = newDatasetName
            items[index].datasetContent = datasetContent
            this.Dataset.records = items
            // 关闭弹窗
            this.popupData.update.datasetName = ''
            this.popupData.update.datasetContent = ''
            this.getDatasetPageList(1)
            this.cancelPopup()
          } else {
            this.$message.error(result.returnMsg)
          }
        })
      }
    },
    // 取消弹窗
    cancelPopup() {
      this.popupActive = ''
      // TODO:弹窗数据传递
      // this.popupData = this.Dataset.records[idx];
    },
    // 分页器点击
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      // this.currentPage = pageIndex
      if (this.display === 'datasetList') {
        this.Dataset.current = pageIndex
        this.getDatasetPageList(pageIndex)
      } else {
        this.versionSet.current = pageIndex
        this.getMyDatasetVersionList(pageIndex)
      }
    },
    // 搜索
    searchDatasetByName() {
      this.getDatasetPageList()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './pretrain_common.scss';

$box_shadow: 0px 2px 6px 0px rgba(15, 15, 17, 0.05);

.dataset-list {
  box-shadow: $box_shadow;
  background: $background_content;
  position: relative;
  .header {
    h3 {
      display: flex;
      align-items: center;
      .modelName-span {
        max-width: 550px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
      }
      .go-model {
        color: $active_color;
        cursor: pointer;
      }
    }
    .tools {
      display: flex;
      .el-input {
        width: 240px;
        margin-right: 15px;
        &::v-deep .el-input__inner {
          height: 36px;
          border-color: #d9deea;
          border-radius: 0;
          &:hover {
            border-color: #d9deea;
          }
        }
      }
      .icon-search-box {
        vertical-align: -13px;
        padding-right: 5px;
      }
      .btn-create {
        color: #fff;
        height: 36px;
        font-size: 14px;
        background: $bgc_btn_primary;
        border-radius: 5px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
        }
      }
      // .btn-create {
      //   position: relative;
      //   width: 32px;
      //   height: 32px;
      //   border: 0 none;
      //   outline: 0 none;
      //   border-radius: 50%;
      //   background-color: $bgc_btn_primary;
      //   cursor: pointer;
      //   &::before,
      //   &::after {
      //     display: inline-block;
      //     position: absolute;
      //     top: 0;
      //     right: 0;
      //     bottom: 0;
      //     left: 0;
      //     width: 16px;
      //     height: 2px;
      //     margin: auto;
      //     background-color: #fff;
      //     content: '';
      //   }
      //   &::after {
      //     transform: rotate(90deg);
      //   }
      //   &:hover,
      //   &:focus {
      //     background-color: $bgc_btn_primary_hover;
      //   }
      //   &:active {
      //     background-color: $bgc_btn_primary;
      //   }
      // }
    }
  }
  .main {
    padding: 20px;
    margin-bottom: 50px;
  }
  .pagination {
    padding: 0;
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .tb-data {
    box-sizing: border-box;
    width: 100%;
    color: $font_333_color;
    font-size: $font_size;
    text-align: center;
    .tb-head {
      height: 50px;
      line-height: 50px;
      background-color: #f2f6ff;
    }
    tbody {
      tr {
        overflow: hidden;
        text-overflow: ellipsis;
        height: 50px;
        border-bottom: 1px solid #d6dcea;
        white-space: nowrap;
        line-height: 50px;
        &.tb-body-r:hover {
          background-color: #f2f6ff;
        }
      }
    }
    .tb-name {
      overflow: hidden;
      text-overflow: ellipsis;
      box-sizing: border-box;
      min-width: 15em;
      width:34em;
      max-width:34em;
      padding: 0 30px;
      text-align: left;
      white-space: nowrap;
    }
    .tb-tags {
      // min-width: 200px;
      .edition {
        color: #0dbe7e;
        cursor: pointer;
      }
      &:empty::before {
        content: '--';
      }
    }
    .tb-action {
      min-width: 180px;
      width: 180px;
      .btn-color {
        color: #4c88ff;
      }
      .btn-forbid {
        cursor: default;
      }
    }
    .tb-action-version {
      width: 280px;
    }
    .sep {
      display: inline-block;
      height: 1em;
      width: 1px;
      margin: 0 10px;
      vertical-align: middle;
      background-color: #d6dcea;
    }
    .btn-opt {
      // width: 37px;
      height: 37px;
      font-size: 14px;
      padding: 10px;
      border: 0 none;
      outline: 0 none;
      background: transparent;
      vertical-align: middle;
      line-height: 1;
      cursor: pointer;
      &:active {
        opacity: 0.85;
      }
      .icon_box {
        width: 16px;
        height: 16px;
        line-height: 1;
        &.icon-edi {
          background: url('../../assets/images/trainingCenter/icon_edit.png')
            no-repeat center;
          background-size: contain;
        }
        &.icon-del {
          background: url('../../assets/images/trainingCenter/icon_delete.png')
            no-repeat center;
          background-size: contain;
        }
      }
    }
  }
  .popup-list .popup-update .intxt .label {
    min-width: 7em;
  }

  .popup-list {
    .popup-delete {
      .content {
        padding: 20px 0;
      }
    }
  }
}
</style>
